import ResultWord from "./ResultWord";
export default ResultWord;
